<div class="list-tasks" [class.list-tasks--card]="layout() !== 'standard'">
  <div
    class="list-tasks__dynamic-container"
    [dndDropzone]="disableGroupDrag() ? [] : ['group']"
    (dndDrop)="onGroupDrop($event)"
  >
    <!-- @if (loading()) {
      <div class="d-flex align-items-center justify-content-center my-5">
        <div class="lds-dual-ring"></div>
      </div>
    } -->

    <div dndPlaceholderRef class="list-tasks-group--placeholder"></div>

    @for (group of sortedGroups(); track group.taskGroup.id; let idx = $index) {
      <list-tasks-group
        [group]="group"
        [layout]="layout()"
        [index]="idx"
        [disableGroupDrag]="disableGroupDrag()"
        [showAccordionToggle]="shouldUseAccordion()"
        [expanded]="isGroupExpanded(group.taskGroup.id)"
        (taskDropped)="onGroupTaskDrop($event)"
        (taskStatusChanged)="onTaskStatusChanged($event)"
        (taskClicked)="onTaskClicked($event)"
        (groupEditRequested)="onGroupEditRequested($event)"
        (addTask)="onAddTask($event)"
        (templateAddSelected)="onTemplateAddSelected($event)"
        (accordionToggleRequested)="onAccordionToggle($event)"
      />
    }
  </div>
</div>
